// extracted by mini-css-extract-plugin
export var errorIcon = "_n7-1";
export var nameLogo = "_n7-0";